export const initialStateFilterDetranManagement = {
   ufDetran: 'ES',
   tipoRelatorio: '',
   referencia: ''
}

export const defaultLoaders = [
   { height: '20px' },
   { height: '20px' },
   { height: '20px' },
   { height: '20px' },
   { height: '20px' },
   { height: '20px' },
   { height: '20px' },
   { height: '20px' }
]

export const tipoRelatorioOptions = [
   {
      text: 'Total Intenções Gravame que não efetivaram contrato',
      value: 'TotalIntencoesGravamenaoefetivaramcontrato'
   },
   {
      text: 'Total Intenções Gravame que não emitiram CRV',
      value: 'TotalIntencoesGravameNaoEmitiramCRV'
   },
   {
      text: 'Total Cessão Direito que não efetivaram aditivo',
      value: 'TotalCessaoDireitoNaoEfetivaramAditivo'
   },
   {
      text: 'Total Contratos Registrados não cancelados',
      value: 'TotalContratosRegistradosNaoCancelados'
   },
   {
      text: 'Total Contratos Cancelados',
      value: 'TotalContratosCancelados'
   },
   {
      text: 'Total Uploads Contratos efetuados não cancelados',
      value: 'TotalUploadsContratosEfetuadosNaoCancelados'
   },
   {
      text: 'Total Uploads Contratos Pendentes',
      value: 'TotalUploadsContratosPendentes'
   },
   {
      text: 'Total Contratos Entregues Fisicamente',
      value: 'TotalContratosEntreguesFisicamente'
   },
   {
      text: 'Total Contratos Pendentes Envio',
      value: 'TotalContratosPendentesEnvio'
   },
   {
      text: 'Total Aditivos Registrados não cancelados',
      value: 'TotalAditivosRegistradosNaoCancelados'
   },
   {
      text: 'Total Aditivos Cancelados',
      value: 'TotalAditivosCancelados'
   },
   {
      text: 'Total Uploads Aditivos efetuados não cancelados',
      value: 'TotalUploadsAditivosEfetuadosNaoCancelados'
   },
   {
      text: 'Total Aditivos Pendentes Envio',
      value: 'TotalAditivosPendentesEnvio'
   },
   {
      text: 'Situação Débito Pendências Financeiras',
      value: 'SituacaoDebitoPendenciasFinanceiras'
   },
   {
      text: 'Compensações Financeiras Contratos Cancelados',
      value: 'RelatorioCompensacoesFinanceirasContratosCancelados'
   },
   {
      text: 'Pagamento DUAs Duplicidade',
      value: 'RelatorioPagamentoDUAsDuplicidade'
   },
   {
      text: 'Contrato Registrado por Registradora',
      value: 'RelatorioContratoRegistradoPorRegistradora'
   },
   {
      text: 'Contrato Compõe Guia Pagamento',
      value: 'RelatorioContratoCompoemGuiaPagamento'
   }
]

export const columnLabels: Record<string, string> = {
   cnpjAgenteFinanceiro: 'CNPJ Agente Financeiro',
   nomeAgenteFinanceiro: 'Nome Agente Financeiro',
   chassi: 'Chassi',
   ufGravame: 'UF Gravame',
   ufPlaca: 'UF Placa',
   placa: 'Placa',
   renavam: 'Renavam',
   contrato: 'Contrato',
   numeroContrato: 'N° Contrato',
   dataContrato: 'Data Contrato',
   dataTransacao: 'Data Transação',
   cpfCnpjDevedor: 'CPF/CNPJ Devedor',
   nomeDevedor: 'Nome Devedor',
   observacao: 'Observação',
   tipoContrato: 'Tipo Contrato',
   status: 'Status',
   situacao: 'Situação',
   dataCancelamento: 'Data Cancelamento',
   dataRegistroContrato: 'Data Registro Contrato',
   responsavelRegistroContrato: 'Responsável Registro Contrato',
   cnpjRegistradoraContrato: 'CNPJ Registradora Contrato',
   qtdUpload: 'Qtd Upload',
   dataUpload: 'Data Upload',
   dataEntrega: 'Data Entrega',
   responsavelUpload: 'Responsável Upload',
   numeroAditivo: 'N° Aditivo',
   dataAditivo: 'Data Aditivo',
   tipoAditivo: 'Tipo Aditivo',
   dataRegistroAditivo: 'Data Registro Aditivo',
   dataGeracaoDUA: 'Data Geração DUA',
   responsavelGeracaoDUA: 'Responsável Geração DUA',
   mesAnoDUA: 'Mês/Ano DUA',
   valorDebito: 'Valor Débito',
   valorDesconto: 'Valor Desconto',
   valorPagar: 'Valor Pagar',
   dataRegistro: 'Data Registro',
   mesCredito: 'Mês Crédito',
   anoCredito: 'Ano Crédito',
   valorDua: 'Valor DUA',
   dataPagto: 'Data Pagamento',
   numeroDua: 'Número DUA'
}